import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStepForwards: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="step-forwards,continue"><path d="M17.25 3.25L20.25 6.25L17.25 9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.5 6.25H9.75C6.29822 6.25 3.5 9.04822 3.5 12.5C3.5 15.9518 6.29822 18.75 9.75 18.75H18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconStepForwards;
